import workspaceRepository from "../../respsitory/WorkspaceRepository";
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {WorkspaceSubscriptionHistory} from "@/model/subscription/workspaceSubscriptionHistory";

const getDate = async (workspaceId: string) => {
    try {
        const {data} = await workspaceRepository.findSubscriptionHistories(workspaceId);
        return data.result;
    } catch (e) {
        throw e;
    }
}

const useWorkspaceSubscriptionHistories = (workspaceId: string) => {
    return useQuery<WorkspaceSubscriptionHistory[],AxiosError>({
        queryKey: ["workspaceSubscriptionHistories", workspaceId],
        queryFn: async () => getDate(workspaceId),
        retry: false,
        suspense: false
    })
}

export default useWorkspaceSubscriptionHistories;
